/* import __COLOCATED_TEMPLATE__ from './reply-button.hbs'; */
import Component from '@glimmer/component';

export default class ReplyButton extends Component {}
